<div class="typeahead-wrapper" (focusout)="hideDropdown()">
  <div class="typeahead-row">
    <div class="typeahead-input-col" [class.has-search-icon]="showSearchIcon">
      <i *ngIf="showSearchIcon" class="icofont-ui-search typeahead-search-icon"></i>
      <input
        #searchInput
        type="text"
        class="form-control typeahead-input"
        [placeholder]="placeholder"
        [disabled]="disabled"
        [(ngModel)]="inputValue"
        (input)="handleInput($event)"
        (focus)="showDropdown = loading || options.length > 0"
      />
    </div>
    <div class="typeahead-button-col">
      <button
        [disabled]="disabled || loading"
        class="btn btn-primary typeahead-button"
        type="button"
        (mousedown)="$event.preventDefault()"
        (click)="search()"
      >
        Buscar
      </button>
    </div>
  </div>

  <div class="dropdown" *ngIf="loading || options.length > 0">
    <div class="dropdown-header">
      <button class="close-button" (click)="close()">&times;</button>
    </div>
    <ng-container *ngIf="loading; else dropdownOptions">
      <div class="typeahead-skeleton">
        <div class="typeahead-skeleton-line" *ngFor="let _ of [1,2,3,4,5]"></div>
      </div>
    </ng-container>

    <ng-template #dropdownOptions>
      <button
        *ngFor="let option of options"
        class="dropdown-option"
        (click)="handleOptionClick(option)"
      >
        {{ option.nome }}
      </button>
    </ng-template>
  </div>
</div>
